import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import WorkReportLinksApi from '@/services/apiServiceModules/workReportLinksApi.js'
const workReportLinksApi = new WorkReportLinksApi()

export default class WorkReportLinksDt extends DataTransferModule {
    constructor() {
        super(ModulesMap.WORK_REPORT_LINKS, workReportLinksApi, {
            useCache: true,
        })
    }
}
